import loggingService from '../services/util/loggingService'

var isDebug = false
var path = '/UserAssignment/'

function listAssignedUserDtos (http, userAssignmentDto) {
    loggingService.log(isDebug, 'UserAssignment Service', 'listAssignedUserDtos')
    return http.put(`${path}ListAssignedUserDtos`, userAssignmentDto)
}

function listAssignableUsers (http, userAssignmentDto) {
    loggingService.log(isDebug, 'UserAssignment Service', 'listAssignableUsers')
    return http.put(`${path}ListAssignableUsers`, userAssignmentDto)
}

function reassignUser (http, userAssignmentDto) {
    loggingService.log(isDebug, 'UserAssignment Service', 'reassignUser')
    return http.put(`${path}ReassignUser`, userAssignmentDto)
}

function listAssignedShpoUsers (http, userAssignmentDto) {
    loggingService.log(isDebug, 'UserAssignment Service', 'listAssignedShpoUsers')
    return http.put(`${path}ListAssignedShpoUsers`, userAssignmentDto)
}

export default {
    listAssignedUserDtos: listAssignedUserDtos,
    listAssignableUsers: listAssignableUsers,
    reassignUser: reassignUser,
    listAssignedShpoUsers: listAssignedShpoUsers
}



// WEBPACK FOOTER //
// ./src/services/userAssignmentService.js